// extracted by mini-css-extract-plugin
export var card = "_sa-0";
export var details = "_sa-1";